import React from "react";
import { Card, Accordion, Button } from "react-bootstrap";

export const PrivateBookingCard = ({
  booking,
  index,
  onHeaderClick,
  getCapacityRange,
}) => {
  const capacityRange = getCapacityRange(
    booking.privateBookingDetail.bookingTypeCapacitiesAndAvailability
  );

  const capacityStanding =
    booking?.privateBookingDetail?.bookingTypeCapacitiesAndAvailability?.find(
      (item) => item.standingCapacities
    )?.standingCapacities;
  return (
    <Card className="private-booking-card">
      <Card.Img
        variant="top"
        src={booking.privateBookingDetail.image.mediaItemUrl}
        alt={booking.title}
      />
      <Card.Body>
        <h3 className="venue-name">{booking.privateBookingDetail.name}</h3>
        <div className="venue-capacities">
          {capacityRange && (
            <div className="capacity-badge">
              <img
                src={require("../../assets/img/common/ic_seat.svg")}
                alt="Seat"
                width={24}
                height={24}
              />
              <span>{capacityRange}</span>
            </div>
          )}
          {capacityStanding && (
            <div className="capacity-badge">
              <img
                src={require("../../assets/img/common/ic_standing.svg")}
                alt="Standing"
                width={24}
                height={24}
              />
              <span>{capacityStanding}</span>
            </div>
          )}
        </div>
        <p className="description">
          {booking.privateBookingDetail.description}
        </p>
        <Accordion className="availability-accordion">
          <Card className="card-accordion-transparent w-arrow">
            <Card.Header
              className="availability-header"
              onClick={() => onHeaderClick(index)}
            >
              <Accordion.Toggle as={Button} variant="link" eventKey="0">
                AVAILABILITY
              </Accordion.Toggle>
            </Card.Header>
            <Accordion.Collapse eventKey="0">
              <Card.Body>
                {booking.privateBookingDetail.bookingTypeCapacitiesAndAvailability?.map(
                  (type, typeIndex) => (
                    <React.Fragment key={typeIndex}>
                      {type.standingCapacities ? (
                        <>
                          <div className="booking-detail-wrapper d-flex align-items-start justify-content-between">
                            <div className="booking-details">
                              <div className="booking-type">
                                <strong>{type.typeOfBooking.name}:</strong>
                              </div>
                              {type.numberOfRooms ? (
                                <div>
                                  {type.numberOfRooms} rooms @
                                  {type.typeOfCapacities === "range"
                                    ? `${type.capacitiesRange.min} - ${type.capacitiesRange.max}`
                                    : type.capacities}{" "}
                                  pax
                                  {type.connectingRoom && (
                                    <>
                                      {" "}
                                      /{" "}
                                      {type?.combinedRoom ? (
                                        <>
                                          <br />
                                          {type.combinedRoom} rooms
                                        </>
                                      ) : (
                                        ""
                                      )}{" "}
                                      combined{" "}
                                      {type.typeOfCapacities === "range"
                                        ? type?.combined ||
                                          type.capacitiesRange.max *
                                            type.numberOfRooms
                                        : type?.combined ||
                                          type.capacities *
                                            type.numberOfRooms}{" "}
                                      pax
                                    </>
                                  )}
                                </div>
                              ) : (
                                <div>
                                  {type.typeOfCapacities === "range"
                                    ? `${type.capacitiesRange.min} - ${type.capacitiesRange.max}`
                                    : type.capacities}{" "}
                                  pax
                                </div>
                              )}
                            </div>
                            <div className="availability-time">
                              {type.availability}
                            </div>
                          </div>
                        </>
                      ) : (
                        <div className="booking-detail-wrapper d-flex align-items-start justify-content-between">
                          <div className="booking-details">
                            <div className="booking-type">
                              <strong>{type.typeOfBooking.name}:</strong>
                            </div>
                            {type.numberOfRooms ? (
                              <div>
                                {type.numberOfRooms} rooms @
                                {type.typeOfCapacities === "range"
                                  ? `${type.capacitiesRange.min} - ${type.capacitiesRange.max}`
                                  : type.capacities}{" "}
                                pax
                                {type.connectingRoom && (
                                  <>
                                    {" "}
                                    /{" "}
                                    {type?.combinedRoom ? (
                                      <>
                                        <br />
                                        {type.combinedRoom} rooms
                                      </>
                                    ) : (
                                      ""
                                    )}{" "}
                                    combined{" "}
                                    {type.typeOfCapacities === "range"
                                      ? type?.combined ||
                                        type.capacitiesRange.max *
                                          type.numberOfRooms
                                      : type?.combined ||
                                        type.capacities *
                                          type.numberOfRooms}{" "}
                                    pax
                                  </>
                                )}
                              </div>
                            ) : (
                              <div>
                                {type.typeOfCapacities === "range"
                                  ? `${type.capacitiesRange.min} - ${type.capacitiesRange.max}`
                                  : type.capacities}{" "}
                                pax
                              </div>
                            )}
                          </div>
                          <div className="availability-time">
                            {type.availability}
                          </div>
                        </div>
                      )}
                    </React.Fragment>
                  )
                )}
              </Card.Body>
            </Accordion.Collapse>
          </Card>
        </Accordion>
        {booking?.privateBookingDetail?.bookingUrl && (
          <a
            href={booking?.privateBookingDetail?.bookingUrl}
            className="booking-url-cta"
            target="_blank"
            rel="noopener noreferrer"
          >
            Find Out More
          </a>
        )}
      </Card.Body>
    </Card>
  );
};
